import React from 'react'
import headerAvatar from '../img/header_avatar.png'
import Typewriter from 'typewriter-effect';


const HeaderSection = class extends React.Component {
  render() {
    return (
      <section className="elementor-section header-section">
          <div className="elementor-container">
            <div className="container-fluid">
              <div className="row p-30-0 p-lg-30-0 p-md-15-0">
                <div className="col-lg-12">
                  <div className="art-a art-banner">
                    <div className="art-banner-back"></div>
                    <div className="art-banner-dec"></div>
                    <div className="art-banner-overlay">
                      <div className="art-banner-title">
                        <h1 className="art-banner-title-h mb-15"> 
                          <span> Welcome to My Space! </span><br/><br/>
                        </h1>

                        <div className="art-lg-text art-code mb-25"> &lt;<i>code</i>&gt;&nbsp;
                          <span className="txt-rotate">
                            <span className="wrap"><Typewriter options={{ strings: ['I build web interfaces.', 'I build cross-platform desktop apps.', 'I fix web interfaces issue.'], autoStart: true, loop: true}}/></span>
                          </span> &lt;/<i>code</i>&gt;
                        </div>

                        {/* <div className="art-buttons-frame"> 
                          <a href="https://bslthemes.com/arter-demo/portfolio/" className="art-btn art-btn-md">
                            <span>Explore now</span>
                          </a>
                        </div> */}
                      </div>
                      <img src={headerAvatar} className="art-banner-photo" alt="Photo"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </section>
    )
  }
}

export default HeaderSection